import { useCallback } from 'react';
import { SingSaverRewardsSectionId } from '../cms-blocks/ComparisonTable/constants';
import { useProductBlockAsideModal } from '../components/ProductBlockAsideModal';
import { shouldRenderProductDetailModal } from '../components/ProductDetails/utils/shouldRenderProductDetailModal';
import { CmsProduct } from '../types/cmsProduct';
import { VerticalType } from '../types/cmsTypes';
import useOpenRewardModal from './useOpenRewardModal';

interface UseOfferRewardModalProps {
  vertical: VerticalType;
  componentUniqueKey: string;
}

const displayAsideRewardModal: Array<VerticalType> = [
  'PERSONAL_LOANS',
  'TRAVEL_INSURANCE',
  'CAR_INSURANCE',
];

export const useOfferRewardModal = ({
  vertical,
  componentUniqueKey,
}: UseOfferRewardModalProps) => {
  const { openModal: openRewardModal } = useOpenRewardModal();
  const { openModal: openProductAside } = useProductBlockAsideModal();

  const openModal = useCallback(
    (product: CmsProduct) => {
      if (
        // No uid means no rewardModal hash to match on — the PDP modal could
        // never open, so fall through to the panel (mirrors useProductDetailModal).
        (shouldRenderProductDetailModal(componentUniqueKey, product) &&
          !!product.uid) ||
        displayAsideRewardModal.includes(vertical!)
      ) {
        openRewardModal(product.uid ?? '', componentUniqueKey);
      } else {
        product.url_alias &&
          openProductAside(product.url_alias, SingSaverRewardsSectionId);
      }
    },
    [vertical, componentUniqueKey, openRewardModal, openProductAside],
  );

  return [openModal];
};
